import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import classNames from "classnames";
import Change from "../Change";
import InlineHelp from "../InlineHelp";
import { formatNumber } from "../../lib/number";
import style from "./style.module.scss";
const AnimatedNumber = React.lazy(() => import("../AnimatedNumber"));
export default function SummaryMetric(props) {
    const { label, value = "", suffix, subValue, className, changeValue, changeSuffix, changeType, hideDivider, inlineHelp, animated, color, align, layout, onOver, onOut, onClick, } = props;
    const dividerComp = [];
    if (!hideDivider) {
        dividerComp.push(_jsx("div", { className: style["summary-metric__divider"] }));
    }
    let changeComp;
    if (changeValue) {
        changeComp = (_jsx("div", { className: style["summary-metric__change"], children: _jsx(Change, { value: changeValue, suffix: changeSuffix, changeType: changeType }) }));
    }
    let subValueComp;
    if (subValue) {
        subValueComp = _jsx("div", { className: style["summary-metric__sub-value"], children: subValue });
    }
    //Format the value if it's a number.
    let valueFormatted = value;
    if (typeof value === "number") {
        valueFormatted = formatNumber(value);
    }
    let valueObj = valueFormatted;
    if (animated && typeof value === "number") {
        //We can only animate values that are numbers. So don't do this if it's not a number.
        valueObj = (_jsx(Suspense, { fallback: _jsx("span", {}), children: _jsx(AnimatedNumber, { value: value }) }));
    }
    let metricColor = "";
    if (color) {
        metricColor = color;
    }
    let alignClass = "";
    if (align) {
        alignClass = style[`summary-metric--align-${align}`];
    }
    let valueComp;
    if (typeof value !== "undefined") {
        valueComp = (_jsxs(_Fragment, { children: [valueObj, suffix, changeComp] }));
    }
    //Dispatch events
    function onMouseOver(event) {
        if (onOver) {
            onOver(event, label);
        }
    }
    function onMouseOut(event) {
        if (onOut) {
            onOut(event);
        }
    }
    function onMouseClick(event) {
        if (onClick) {
            onClick(event, label);
        }
    }
    if (layout && layout === "horizontal") {
        return (_jsxs("div", { className: classNames(style["summary-metric"], style["summary-metric--horizontal"], className, alignClass), style: { color: metricColor }, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onClick: onMouseClick, children: [_jsx("div", { className: style["summary-metric__label"], children: label }), _jsxs("div", { className: style["summary-metric--align-right"], children: [_jsx("div", { className: classNames(style["summary-metric__value"], style["summary-metric__value--horizontal"]), children: _jsxs(InlineHelp, { info: inlineHelp, position: "left", children: [valueObj, _jsx("span", { className: style["summary-metric__suffix"], children: suffix }), changeComp] }) }), subValueComp] }), _jsx("div", { className: classNames(style["summary-metric__divider"], style["summary-metric__divider--horizontal"]) })] }));
    }
    return (_jsxs("div", { className: classNames(style["summary-metric"], className, alignClass, "qa-summary-metric"), style: { color: metricColor }, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onClick: onMouseClick, children: [_jsx("div", { className: style["summary-metric__label"], children: _jsx("div", { children: label }) }), dividerComp, _jsxs("div", { className: style["summary-metric__value"], children: [_jsx(InlineHelp, { info: inlineHelp, children: valueComp }), subValueComp] })] }));
}
